import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDebouncedCallback } from 'use-debounce';
import { ButtonHelper } from '../../../NewFitAssistant/Helpers/ButtonHelper.ts';
import { IsProductPage } from '../../../FitAssistantShared/IsProductPage.js';
import { useAppState } from '../../BikesAppState.tsx';

import AssistantBanner from '/Foundation/React/code/Components/AssistantBanner/AssistantBanner.tsx';

import './FitAssistantButton.less';

const FitAssistantButton = () => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);
  const [isPastLastItem, setIsPastLastItem] = useState(false);
  const portalTarget = document.getElementById('fitAssistantHeaderPortal');
  const { fitAssistantBikesData, setShowFitAssistant } = useAppState();

  const translations = fitAssistantBikesData?.Translations;

  const handleScroll = useDebouncedCallback(() => {
    ButtonHelper.HandleStickyButtonOnScroll(buttonRef, setIsSticky);
    if (!IsProductPage) {
      ButtonHelper.HandleBannerVisibilityOnScroll(setIsPastLastItem);
    }
  }, 20);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    ButtonHelper.HandleStickyButtonOnScroll(buttonRef, setIsSticky);
    if (!IsProductPage) {
      ButtonHelper.HandleBannerVisibilityOnScroll(setIsPastLastItem);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleButtonClick = () => {
    setShowFitAssistant(true);
  };

  const FitAssistantContent = () => {
    return (
      <div className="fit-assistant">
        {!IsProductPage ? (
          <AssistantBanner
            icon="le-icon-bike"
            text={translations?.bannerText}
            ctaLabel={translations?.selectBikeModel ?? ''}
            onCtaClick={handleButtonClick}
            onBannerClick={handleButtonClick}
            className="fit-assistant-banner"
          />
        ) : (
          <button
            className={`fit-assistant-button ${IsProductPage ? 'pdp' : ''}`}
            onClick={handleButtonClick}
            tabIndex={0}
          >
            <div className="d-flex align-items-center">
              <i className={'fit-indicator me-5 le-icon-bike'}></i>
              {<span className={`heading6 text-start d-flex align-items-center`}>{translations?.buttonText}</span>}
            </div>
            <div className="icon-wrapper--arrow">
              <i className="le-icon-arrow rot-180"></i>
            </div>
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      <div ref={buttonRef} />
      {portalTarget && isSticky && !IsProductPage && !isPastLastItem ? (
        <>
          {ReactDOM.createPortal(
            <div className="fit-assistant-isotope-constraint">
              <FitAssistantContent />
            </div>,
            portalTarget
          )}
          <div className="fit-assistant-spacer"></div>
        </>
      ) : !IsProductPage && isPastLastItem ? null : (
        <FitAssistantContent />
      )}
    </>
  );
};

export default FitAssistantButton;
